<template>
  <div class="w-full flex flex-col md:flex-row md:!h-full" ref="supportChatModal">
    <!-- chat -->
    <div class="w-full md:w-3/4 flex-1 min-h-[60vh]">
      <div
        class="mb-4 border-b border-gray-200 p-4 flex flex-col md:flex-row justify-between items-center w-full"
      >
        <div class="text-lg font-medium text-txprimary flex-shrink-0">
          Чат с поддержкой Telepost
        </div>
        <div class="flex flex-row items-center justify-between md:justify-end mt-4 md:mt-0 w-full">
          <div
            class="text-primary font-semibold cursor-pointer px-2 py-1 border border-primary rounded-xl hover:opacity-60"
            v-if="isOpenTicket && ticketId"
            @click="isOpenCloseTicketModal = true"
          >
            Закрыть обращение
          </div>
          <div
            v-if="!isDesktop"
            class="text-base text-txprimary font-semibold"
            @click="showMobHistory = !showMobHistory"
          >
            История
          </div>
        </div>
        <div v-if="!isDesktop && showMobHistory" class="p-4 text-left w-full">
          <div
            v-if="allSupportTickets.data"
            v-for="ticket in allSupportTickets.data"
            :key="ticket.id"
            class="flex gap-2 items-center mb-2 cursor-pointer"
            @click="
              scrollToTicket(ticket.id);
              showMobHistory = false;
            "
          >
            <Icon name="mdi:chat-outline" class="w-6 h-6" />
            <div class="text-sm text-txprimary">
              {{ dayjs(ticket.created).format("DD.MM.YYYY") }}
            </div>
            <div class="text-sm text-txprimary">
              {{ themes[ticket.theme as keyof typeof themes] }}
            </div>
            <Icon name="mdi:star" class="w-4 h-4 text-yellow-400" />
            <div class="text-sm text-txprimary">{{ ticket.rating ?? "?" }}</div>
          </div>
        </div>
      </div>
      <div
        class="flex-1 flex flex-col overflow-y-scroll h-[50vh] md:pr-2 mb-2 px-2 md:px-4"
        ref="scrollContent"
      >
        <div class="flex-1 flex flex-col justify-end mb-4">
          <div v-for="(datesData, dates) in chatMessages">
            <div
              class="text-xs font-semibold text-txprimary bg-white w-fit mx-auto px-2.5 py-1 rounded-xl mt-4"
            >
              {{ dayjs.utc(datesData[0].created).local().locale("ru").format("DD MMMM") }}
            </div>
            <div
              v-for="(message, index) in datesData"
              :data-message-id="message.messageId"
              :data-ticket-id="message.ticketId"
            >
              <!-- ticket point -->
              <div
                v-if="ticketPoint(message.ticketId)"
                class="opacity-0 pointer-events-none"
                :id="`ticket-${message.ticketId}`"
              />
              <div
                v-if="
                  message.userType === 'PUBLISHER' &&
                  (!datesData[index - 1] || datesData[index - 1].userType !== 'PUBLISHER')
                "
                class="right-message flex items-end gap-2 mb-4"
              >
                <div>
                  <NuxtImg
                    :src="avatar ? avatar : '/assets/img/preview_logo.svg'"
                    class="size-8 rounded-full"
                  />
                </div>
                <div class="flex flex-col -gap-1 items-end">
                  <div
                    class="text-txprimary text-sm leading-[20px] truncate max-w-[20ch] border-b font-bold"
                  >
                    {{ "Вы" }}
                  </div>
                </div>
              </div>
              <!-- сообщение паблишера -->
              <div
                class="flex flex-col gap-1 right-messages mb-4 pl-4"
                v-if="message.userType === 'PUBLISHER'"
              >
                <div
                  class="right-messages__item text-sm text-[#3A3D44] !bg-primary w-fit p-3 rounded-2xl rounded-tl-[0] relative whitespace-break-spaces"
                >
                  {{ message.content }}
                  <ChatAttachments :files="message.files" dark :class="{ 'mt-2': message.content }" />
                  <div class="absolute -top-4 -right-0 text-[.5rem] text-primary">
                    {{ dayjs.utc(message.created).local().format("HH:mm") }}
                  </div>
                </div>
              </div>

              <!-- системное сообщение -->
              <div
                v-if="
                  (message.userType === 'ADMIN' &&
                    (!datesData[index - 1] || datesData[index - 1].userType !== 'ADMIN')) ||
                  (message.userType === 'SYSTEM' &&
                    (!datesData[index - 1] || datesData[index - 1].userType !== 'SYSTEM'))
                "
                class="flex items-center gap-2 px-0 md:px-4"
              >
                <div
                  class="bg-primary/10 size-8 rounded-full mb-5 flex items-center justify-center"
                >
                  <UINewIconsISupport class="fill-primary size-6" />
                </div>
                <div>
                  <div
                    class="font-semibold text-txprimary leading-[20px] truncate max-w-[20ch] border-b"
                  >
                    {{ "Поддержка Telepost" }}
                  </div>
                </div>
              </div>
              <div
                class="flex flex-col gap-1 mb-4 pl-0 md:pl-4"
                v-if="message.userType === 'ADMIN' || message.userType === 'SYSTEM'"
              >
                <div
                  class="text-[14px] font-normal text-black bg-bgnew border w-fit p-3 rounded-xl rounded-tl-[0] relative whitespace-break-spaces"
                >
                  {{ message.content }}
                  <ChatAttachments :files="message.files" :class="{ 'mt-2': message.content }" />
                  <div
                    class="absolute -top-4 -left-0 text-[.5rem] text-txopacity mb-1"
                    v-if="message.userType !== 'SYSTEM'"
                  >
                    {{ dayjs.utc(message.created).local().format("HH:mm") }}
                  </div>
                </div>
              </div>
              <div v-if="showLine(index, datesData, messages)">
                <div class="flex items-center gap-2 px-4 justify-between mb-4">
                  <div class="flex-1 h-[1px] bg-primary"></div>
                  <div class="px-2 mx-2 whitespace-nowrap text-primary">Обращение закрыто</div>
                  <div class="flex-1 h-[1px] bg-primary"></div>
                </div>
                <PublisherDialogsSupportRating
                  :tickets="allSupportTickets"
                  :ticketId="showLine(index, datesData, messages)"
                  @rate="rateTicket"
                />
              </div>
            </div>
          </div>
          <SupportChatMenu
            v-if="!isOpenTicket"
            :systemMenuType="systemMenuType"
            @update:systemMenuType="systemMenuType = $event"
            bg="bg-bgnew"
          />
        </div>
      </div>
      <div
        class="bg-white md:rounded-2xl md:mr-2 relative min-h-[4rem] px-4 py-2 md:py-5 md:px-4 flex flex-row items-center justify-between gap-2 md:gap-4 flex-shrink-0"
      >
        <span v-if="isTyping" class="text-xs text-txprimary absolute -top-6"
          >{{ "Поддержка" }} печатает...
        </span>

        <ChatAttachButton
          ref="attachments"
          side="publisher"
          :disabled="!isOpenTicket && systemMenuType === ''"
        />

        <el-input
          v-model="newMessage"
          class="el-custom-input-textarea"
          placeholder="Ваше сообщение..."
          type="textarea"
          autosize
          :disabled="!isOpenTicket && systemMenuType === ''"
          @keyup.enter.ctrl="sendMessage"
        >
          <template #prefix>
            <Icon name="mdi:send" class="size-5 text-white" />
          </template>
        </el-input>

        <Button
          :button-text="isDesktop ? 'Отправить' : ''"
          button-class="!w-fit !px-3 md:!px-7 md:!py-1.5 !rounded-xl !min-w-[44px] max-md:!h-[2.75rem]"
          @click="sendMessage"
          :disabled="!canSend"
        >
          <template #prefix v-if="!isDesktop">
            <Icon name="mdi:send" class="size-5 text-white" />
          </template>
        </Button>
      </div>
    </div>
    <!-- history -->
    <div v-if="isDesktop" class="w-full md:w-1/4 flex-shrink-0 border-l border-gray-200 p-4">
      <div class="text-lg font-medium text-txprimary mb-4">История обращений</div>
      <div
        v-if="allSupportTickets.data"
        v-for="ticket in allSupportTickets.data"
        :key="ticket.id"
        class="flex gap-2 items-center mb-2 cursor-pointer"
        @click="scrollToTicket(ticket.id)"
      >
        <Icon name="mdi:chat-outline" class="w-6 h-6" />
        <div class="text-sm text-txprimary">{{ dayjs(ticket.created).format("DD.MM.YYYY") }}</div>
        <div class="text-sm text-txprimary">{{ themes[ticket.theme as keyof typeof themes] }}</div>
        <Icon name="mdi:star" class="w-4 h-4 text-yellow-400" />
        <div class="text-sm text-txprimary">{{ ticket.rating ?? "?" }}</div>
      </div>
    </div>
  </div>
  <!-- close ticket modal -->
  <PublisherModalsEmptyModal
    :open="isOpenCloseTicketModal"
    @update:open="isOpenCloseTicketModal = $event"
    classes="!bg-white !mt-80"
    width="450px"
    :to="supportChatModal"
  >
    <PublisherModalsCloseTicket
      :ticketId="ticketId"
      status="OPEN"
      @cancel="isOpenCloseTicketModal = false"
      @confirm="ticketAction"
    />
  </PublisherModalsEmptyModal>
</template>

<script lang="ts" setup>
  import chatService from "~/services/chatService";
  import dayjs from "dayjs";
  import { useSocketChat } from "~/composables/useSocketChat";
  import { useScreenSize } from "~/helpers/isMobile";
  import { ChatUserType, type IMessage, type ISendSystemMessage } from "~/interfaces/chat";
  import { usePublisherStore } from "~/store/PublisherModule";
  import utc from "dayjs/plugin/utc";
  import timezone from "dayjs/plugin/timezone";
  import { Button } from "~/components/UINew";
  import SupportChatMenu from "~/components/publisher/dialogs/SupportChatMenu.vue";

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const supportChatModal = ref<HTMLElement | undefined>(undefined);

  const { isDesktop } = useScreenSize();
  const {
    leaveChat,
    leaveTicket,
    joinTicket,
    joinChat,
    supportSocket,
    socket,
    connect,
    handleNewMessage,
    isListeningMessages,
    setupTypingTimer,
    handleTyping,
    isTyping,
  } = useSocketChat();
  const userStore = usePublisherStore();
  const userId = +userStore.id;
  const avatar = computed(() => userStore.avatar ?? null);

  const scrollContent = ref<HTMLElement | null>(null);
  const messages = ref<IMessage[]>([]);
  const newMsg = ref<IMessage | null>(null);
  const isOpenCloseTicketModal = ref(false);
  const ticketId = ref<number>(0);
  const isOpenTicket = ref(false);
  const allSupportTickets = ref<any>({});
  const newMessage = ref<string>("");
  const attachments = ref<any>(null);
  const systemMenuType = ref<string>("");
  const showMobHistory = ref(false);

  dayjs.extend(utc);

  // Своё сообщение сокет обратно не присылает — добавляем его из ответа POST.
  // Дубликат отсекаем по messageId на случай, если эхо всё же придёт.
  const appendMessage = (data: any) => {
    if (!data) return;
    if (data.messageId && messages.value.some((item: any) => item.messageId === data.messageId)) {
      return;
    }
    messages.value.push(data);
  };

  // Сообщение уходит, если есть текст или хотя бы одно вложение
  const canSend = computed(() => {
    if (!isOpenTicket.value && systemMenuType.value === "") return false;
    if (attachments.value?.isUploading) return false;
    return newMessage.value.trim() !== "" || (attachments.value?.files?.length ?? 0) > 0;
  });

  const sendMessage = async () => {
    if (!canSend.value) return;

    if (!ticketId.value || ticketId.value <= 0) {
      const result: any = await chatService.createSupportTicket({
        userId: +userStore.id,
        theme: systemMenuType.value.toUpperCase(),
      });
      if (result.id) {
        isOpenTicket.value = true;
        ticketId.value = result.id;
      }
    }
    if (!ticketId.value) return;

    const sendData: ISendSystemMessage = {
      ticketId: ticketId.value,
      userType: ChatUserType.PUBLISHER,
      content: newMessage.value,
      files: attachments.value?.files ?? [],
    };

    const sent: any = await chatService.sendSystemMessage(sendData);
    newMessage.value = "";
    attachments.value?.reset();
    appendMessage(sent);
    await nextTick();
    if (scrollContent.value) {
      scrollContent.value.scrollTo({
        top: scrollContent.value.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const themes = {
    OTHER: "Другое",
    PAYMENT: "Выплаты",
    ORDER: "Заказ",
    CHANNEL: "Канал",
  };

  const chatMessages = computed(() => {
    const result: any = {};
    messages.value.map((item: IMessage) => {
      const date = dayjs.utc(item.created).local().format("DD-MM-YYYY");
      if (!result[date]) {
        result[date] = [];
      }
      result[date].push(item);
    });
    return result;
  });

  const startTyping = (event: number) => {
    setupTypingTimer(ticketId.value, "support");
  };

  watch(
    () => ticketId.value,
    (newVal, oldVal) => {
      if (newVal <= 0 || newVal === oldVal) return;
      if (supportSocket) {
        if (oldVal && oldVal <= 0) {
          leaveTicket(oldVal);
        }
        joinTicket(ticketId.value);
      }
    },
    { deep: true, immediate: true }
  );

  watch(
    () => newMsg.value,
    async (newMessage) => {
      if (newMessage) {
        messages.value.push(newMessage);

        await nextTick();
        if (scrollContent.value) {
          scrollContent.value.scrollTo({
            top: scrollContent.value.scrollHeight,
            behavior: "smooth",
          });
        }
      }
    },
    { deep: true }
  );

  watch(
    () => newMessage.value,
    () => {
      setupTypingTimer(ticketId.value, "support");
    }
  );

  const getTicketData = async () => {
    const userStore = usePublisherStore();
    const supportTickets: any = await chatService.getSupportTickets({
      userId: +userStore.id,
      userType: "PUBLISHER",
    });
    const lastTicket = supportTickets.data[0];
    allSupportTickets.value = supportTickets;
    ticketId.value = lastTicket?.id || 0;
    isOpenTicket.value = lastTicket && lastTicket?.status !== "CLOSE";
    const baseMessages = await chatService.getUserMessages();
    if (baseMessages) {
      messages.value = [...baseMessages];
    }
    if (lastTicket.status === "CLOSE") {
      isOpenTicket.value = false;
      ticketId.value = 0;
      messages.value.push({
        chatId: 0,
        content: "Активных запросов нет.\nПожалуйста, выберите тему обращения:",
        isRead: false,
        created: new Date(),
        messageId: 0,
        replyTo: null,
        status: "sent",
        userId: 0,
        userType: ChatUserType.SYSTEM,
      });
    }
  };

  const ticketPointId = ref<number[]>([]);
  const ticketPoint = (ticketId: number) => {
    if (ticketPointId.value.includes(ticketId)) return false;
    ticketPointId.value.push(ticketId);
    return true;
  };

  const showLine = (index: number, datesData: IMessage[], allMessages: IMessage[]) => {
    // Проверяем следующее сообщение в текущей дате
    if (index < datesData.length - 1) {
      if (!datesData[index + 1].chatId && datesData[index + 1].chatId === 0)
        return datesData[index].ticketId;
      return datesData[index].ticketId !== datesData[index + 1].ticketId
        ? datesData[index].ticketId
        : null;
    }

    // Проверяем первое сообщение следующей даты
    const currentMessage = datesData[datesData.length - 1];
    const currentIndex = allMessages.findIndex((msg) => msg.messageId === currentMessage.messageId);

    if (currentIndex < allMessages.length - 1) {
      const nextMessage = allMessages[currentIndex + 1];
      return currentMessage.ticketId !== nextMessage.ticketId ? currentMessage.ticketId : null;
    }

    return null;
  };

  const rateTicket = async (rating: number, ticketId: number) => {
    const result: any = await chatService.rateTicket(ticketId, rating);
    if (result) {
      await getTicketData();
    }
  };

  const ticketAction = async () => {
    if (!ticketId.value || ticketId.value < 1) return;
    await chatService.closeTicket(ticketId.value);
    isOpenCloseTicketModal.value = false;
    await getTicketData();
  };

  onMounted(async () => {
    const apiKey = useCookie("authorizedP").value;
    if (apiKey) {
      connect(apiKey, "support");
    }

    handleNewMessage((data: any) => {
      newMsg.value = data;
    }, "support");

    await getTicketData();

    await nextTick();
    if (scrollContent.value) {
      scrollContent.value.scrollTo({
        top: scrollContent.value.scrollHeight,
        behavior: "smooth",
      });
    }
  });

  const scrollToTicket = (targetTicketId: number) => {
    // Ищем первое сообщение с нужным ticketId
    let targetMessage: IMessage | null = null;

    for (const message of messages.value) {
      if (message.ticketId === targetTicketId) {
        targetMessage = message;
        break;
      }
    }

    if (!targetMessage) {
      return;
    }

    // Ищем элемент по messageId или другому уникальному атрибуту
    nextTick(() => {
      // Попробуем найти элемент по data-атрибуту или классу
      const messageElements = scrollContent.value?.querySelectorAll("[data-message-id]");
      let targetElement: Element | null = null;

      messageElements?.forEach((el) => {
        if (el.getAttribute("data-message-id") === targetMessage.messageId.toString()) {
          targetElement = el;
        }
      });

      if (targetElement && scrollContent.value) {
        (targetElement as HTMLElement).scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  };

  onUnmounted(() => {
    leaveTicket(ticketId.value);
  });
</script>

<style scoped lang="scss">
  .right-message {
    flex-direction: row-reverse;
  }

  .right-messages {
    @apply items-end;

    &__item {
      @apply rounded-tl-[12px] rounded-tr-[0] bg-[#00aee8] text-white font-[600];
    }
  }
  /* Для WebKit-браузеров (Chrome, Safari) */
  ::-webkit-scrollbar {
    width: 4px;
    /* Ширина полосы прокрутки */
  }

  ::-webkit-scrollbar-track {
    // background: #f0f7f9;
    /* Цвет фона полосы прокрутки */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #3176ff;
    /* Цвет ползунка */
    border-radius: 1px;
    /* Радиус скругления ползунка */
    border: 1px solid #f0f9fc;
    /* Отступ между ползунком и треком */
    margin-right: -5px !important;
  }

  :deep(.el-custom-input-textarea) {
    .el-textarea__inner {
      @apply w-full placeholder:text-[#99ABBA] rounded-xl p-4 bg-white outline-none border border-[#E9E6F3] focus:border-primary !min-h-[50px] !max-h-[100px];
    }
  }
</style>
